import {PathwaysContextPadProvider} from '@ispm-client/modules/bpmn-modeler/bpmn/pathways-contextpad-provider';
import {CustomRenderer} from '@ispm/shared/bpmn-io/custom-renderer';
import {ConnectionDragRule} from '@ispm-client/modules/bpmn-modeler/bpmn/rules/connection-drag-rule';
import {SelectionBehavior} from '@ispm-client/modules/bpmn-modeler/bpmn/behavior/selection-behavior';
import {BpmnExtensionHelper} from '@ispm/shared/bpmn-io/bpmn-extension-helper';
import {AddConnectionEndBehavior} from '@ispm-client/modules/bpmn-modeler/bpmn/behavior/add-connection-end-behavior';
import {Store} from '@ngrx/store';
import {State} from '@ispm-client/modules/bpmn-modeler/store/state';
import {TreeNavigator} from '@ispm/shared/bpmn-io/services/tree-navigator';
import {PathwaysViewerCommands} from '@ispm/shared/bpmn-io/pathways-viewer-commands';
import {EmptyBendpointMove} from '@ispm-client/modules/bpmn-modeler/bpmn/empty-bendpoint-move';
import {PathwaysPaletteProvider} from '@ispm-client/modules/bpmn-modeler/bpmn/pathways-palette-provider';
import {ElementAutoResizeRule} from '@ispm-client/modules/bpmn-modeler/bpmn/rules/element-auto-resize-rule';
import {ElementRuleMove} from '@ispm-client/modules/bpmn-modeler/bpmn/rules/element-rule-move';
import {IdGenerator} from '@ispm-client/modules/bpmn-modeler/bpmn/utils/id-generator';
import {CustomLassoTool} from '@ispm-client/modules/bpmn-modeler/bpmn/lasso-tool/custom-lasso-tool';
import {ShapeFocus} from '@ispm/shared/bpmn-io/services/shape-focus';
import {CustomTextRenderer} from '@ispm/shared/bpmn-io/text/custom-text-renderer';
import {TreeRepair} from '@ispm-client/modules/bpmn-modeler/bpmn/TreeRepair';
import {PathwayPreviewSupport} from '@ispm-client/modules/bpmn-modeler/bpmn/pathway-preview-support';
import {LazyLoadingExtensionModule} from '@ispm/shared/bpmn-io/lazy-loading-extension-module';
import {NeighborhoodHeadNameUpdater} from '@ispm-client/modules/bpmn-modeler/bpmn/utils/neighborhood-head-name-updater';
import {PreSaveHandler} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/pre-save-handler';
import {ContextPadCreateBehavior} from '@ispm-client/modules/bpmn-modeler/bpmn/behavior/context-pad-create-behavior';
import {FloatingNodesConnectionEndBehaviour} from "@ispm/shared/bpmn-io/floating-nodes-connection-end-behaviour";
import {NodeSelectionDependenciesFix} from "@ispm-client/modules/bpmn-modeler/bpmn/node-selection-dependencies-fix";
import {FloatingNodesService} from "@ispm/shared/bpmn-io/services/floating-nodes-service";
import {AfterParseCompleteBehavior} from "@ispm/shared/bpmn-io/behavior/after-parse-complete-behaviour";
import {AddConnectionOutBehavior} from "@ispm-client/modules/bpmn-modeler/bpmn/behavior/add-connection-out-behavior";
import {CustomCanvas} from "@ispm/shared/bpmn-io/CustomCanvas";
import {CustomOrdering} from "@ispm/shared/bpmn-io/custom-ordering";
import {CustomHandTool} from "@ispm/shared/bpmn-io/CustomHandTool";


export function getModelerExtensionModule(store$: Store<State>) {
    return {
        __init__: [
            'store$', 'pathwaysContextPadProvider', 'contextPadProvider', 'pathwaysPaletteProvider',
            'paletteProvider', 'bpmnRenderer', 'defaultRenderer', 'customRules', 'treeNavigator', 'autoPlaceSelectionBehavior'
            , 'bpmnExtensionHelper', 'addConnectionEndBehavior','addConnectionOutBehavior',
            'pathwaysViewerCommands', 'shapeFocus', 'bendpointMove', 'elementAutoResizeRule', 'elementRuleMove',
            'idGenerator', 'lassoTool', 'textRenderer', 'TreeRepair', 'previewSupport', 'neighborhoodHeadNameUpdater', 'preSaveHandler',
            'contextPadCreateBehavior', 'floatingNodesConnectionEndBehaviour', 'nodeSelectionDependenciesFix','floatingNodesService',
            'afterParseCompleteBehavior','canvas','orderingProvider','handTool'
        ],
        __depends__: [LazyLoadingExtensionModule],
        store$: ['value', store$],
        pathwaysContextPadProvider: ['type', PathwaysContextPadProvider],
        pathwaysPaletteProvider: ['type', PathwaysPaletteProvider],
        bpmnRenderer: ['type', CustomRenderer],
        customRules: ['type', ConnectionDragRule],
        shapeFocus: ['type', ShapeFocus],
        treeNavigator: ['type', TreeNavigator],
        autoPlaceSelectionBehavior: ['type', SelectionBehavior],
        bpmnExtensionHelper: ['type', BpmnExtensionHelper],
        addConnectionEndBehavior: ['type', AddConnectionEndBehavior],
        addConnectionOutBehavior: ['type', AddConnectionOutBehavior],
        pathwaysViewerCommands: ['type', PathwaysViewerCommands],
        bendpointMove: ['type', EmptyBendpointMove],
        elementAutoResizeRule: ['type', ElementAutoResizeRule],
        elementRuleMove: ['type', ElementRuleMove],
        // functionality we don't need from bpmn
        dropOnFlowBehavior: ['type', Object],
        contextPadProvider: ['type', Object],
        paletteProvider: ['type', Object],
        defaultRenderer: ['type', Object],
        idGenerator: ['type', IdGenerator],
        lassoTool: ['type', CustomLassoTool],
        textRenderer: ['type', CustomTextRenderer],
        TreeRepair: ['type', TreeRepair],
        previewSupport: ['type', PathwayPreviewSupport],
        neighborhoodHeadNameUpdater: ['type', NeighborhoodHeadNameUpdater],
        preSaveHandler: ['type', PreSaveHandler],
        contextPadCreateBehavior: ['type', ContextPadCreateBehavior],
        floatingNodesConnectionEndBehaviour: ['type', FloatingNodesConnectionEndBehaviour],
        nodeSelectionDependenciesFix: ['type', NodeSelectionDependenciesFix],
        floatingNodesService: ['type', FloatingNodesService],
        afterParseCompleteBehavior: ['type', AfterParseCompleteBehavior],
        canvas: ['type',CustomCanvas],
       orderingProvider: ['type',CustomOrdering],
      handTool: ['type',CustomHandTool]

    };
}

